import { PromotionEnumType } from "../enums/promotionEnum"

export const convertPromotionTypeToText=(value:string):string=>{
    if(value===PromotionEnumType.buy_x_get_x){
        return "ໍຊື້ 1 ແຖມ 1";
    }
    else if(value===PromotionEnumType.buy_x_get_ds){
        return "ຫຼຸດລາຄາ";
    }
    else {
        return value;
    }
}